




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GroupChatViewObject, ChatMember } from '@/types/apiServerContract';
import { ChatModule } from '@/store/modules/chat/chat.store';
import { ModalConstants, BusConstants } from '@/core/constants';

import GroupChatMember from './GroupChatMember.vue';
import bus from '@/core/bus';

@Component({
    components: {
        GroupChatMember
    }
})
export default class EditGroupChat extends Vue {
	@Prop({ required: true }) chat!: GroupChatViewObject;

	id: string = ModalConstants.EditGroupChat;

	name: string = this.chat.name;
	image: string = this.chat.image;
	loading: boolean = false;

	get members() {
	    return this.chat.members.sort((a, b) => (a.author === this.chat.owner ? -1 : 1));
	}

	async updateGroupChatName() {
	    this.loading = true;

	    try {
	        await ChatModule.UpdateGroupChatName({ groupId: this.chat.id, name: this.name });
	    } finally {
	        this.loading = false;
	    }
	}

	async updateGroupChatImage() {
	    this.loading = true;

	    try {
	        await ChatModule.UpdateGroupChatImage({ groupId: this.chat.id, image: this.image });
	    } finally {
	        this.loading = false;
	    }
	}

	async kickMember(member: ChatMember) {
	    const check = await this.$bvModal.msgBoxConfirm(`Are you sure you wish to kick ${member.authorName}`, {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    await ChatModule.KickMember({ groupId: this.chat.id, memberId: member.author });

	    this.$bvToast.toast(`${member.authorName} has been kicked`, {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	Reset() {
	    this.name = this.chat.name;
	}

	groupChatDisbanded(groupId: string) {
	    if (this.chat.id === groupId) {
	        this.$bvModal.hide(ModalConstants.EditGroupChat);

	        this.$bvToast.toast('Chat has been disbanded', {
	            variant: 'success',
	            title: 'Success'
	        });
	    }
	}

	created() {
	    bus.on(BusConstants.GroupChatDisbanded, this.groupChatDisbanded);
	}

	beforeDestroy() {
	    bus.off(BusConstants.GroupChatDisbanded, this.groupChatDisbanded);
	}
}
